'use strict';

angular.module('mean.projects').factory('projectOptionService', ['$filter', 'ProjectBids', '$q', 'taskService', 'toaster', 'aceUtils', 'optionService', 'taskTotalsService',
    function($filter, ProjectBids, $q, taskService, toaster, aceUtils, optionService, taskTotalsService) {

        // This function finds the projectBid from bid_tasks that
        // is associated with the provided subtask and
        // returns the bid total.
        var getProjectBidTotal = function(subtask, bid_tasks) {
            var bid_task = $filter('filter')(bid_tasks, {
                'plan_code': subtask.plan,
                'task_code': subtask.code }, true);

            if(bid_task.length !== 1) {
                toaster.pop('error', 'Project Bid Task', 
                    'Could not find the project bid associated with this subtask ' 
                        + subtask.name);
                return;
            }

            return bid_task[0].subtasks[subtask.subtask_array_id]?
                bid_task[0].subtasks[subtask.subtask_array_id].total:0;
        };

        // This function finds the projectBid from bid_tasks that
        // is associated with the provided subtask and
        // returns the bid total.
        var getProjectOriginalBidTotal = function(subtask, bid_tasks) {
            var bid_task = $filter('filter')(bid_tasks, {
                'plan_code': subtask.plan,
                'task_code': subtask.code }, true);

            if(bid_task.length !== 1) {
                toaster.pop('error', 'Project Bid Task', 
                    'Could not find the project bid associated with this subtask ' 
                        + subtask.name);
                return;
            }

            if(!bid_task[0].subtasks[subtask.subtask_array_id])
                return 0;

            if(!bid_task[0].subtasks[subtask.subtask_array_id].is_original)
                return 0;

            if(bid_task[0].subtasks[subtask.subtask_array_id].is_option &&
                bid_task[0].subtasks[subtask.subtask_array_id].is_original){
                return bid_task[0].subtasks[subtask.subtask_array_id].original_total;
            } else {
                if(!bid_task[0].subtasks[subtask.subtask_array_id].is_option)
                  return bid_task[0].subtasks[subtask.subtask_array_id].total;
                else
                  return 0;
            }
        };

        // this function will take in a project_bid and it's associated
        // original bid to reconstruct the data so subtasks, materials,
        // and equipment are all in place just like the original bid.
        var convertProjectBidToBid = function(project_bid, original_bid) {
            var return_bid = {};

            return_bid.plan_code = original_bid;
            return_bid.task_id = original_bid;
            return_bid.labor = original_bid;
            return_bid.materials = original_bid;
            return_bid.equipment = original_bid;

            _.each(original_bid.subtasks, function(subtask) {
                
            });

            return return_bid;
        };

        function getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min)) + min;
        }

        var addProjectBidSubtaskFromSubtask = function(subtask, bid, item) {
            var new_sub = {
                task_id: bid.subtasks.length,
                name: subtask.name,
                crew_rate: subtask.crew_rate,
                current_net_pay: subtask.current_net_pay,
                piece_per_hour_rate: subtask.piece_per_hour_rate,
                piece_rate: subtask.piece_rate,
                unit: subtask.unit,
                is_option: true,
                is_multiple: item.is_multiple,
                multi_data: [{
                    option_number: item.number,
                    multiple: item.multiple,
                    lot: item.lot,
                    phase: item.phase
                }],
                option_number: item.number,
                is_original: false,
                original_total: subtask.total,
                bid_hours: subtask.bid_hours,
                hours_allowed: subtask.hours_allowed,
                work_comp: subtask.work_comp,
                labor_total: subtask.labor,
                bid_mark_up: subtask.bid_mark_up,
                general_liability: subtask.general_liability,
                total: subtask.is_overridden ? subtask.overridden_total : subtask.total,
                material_total: subtask.material_total,
                materials_subtotal: subtask.materials_subtotal,
                materials_dev_subtotal: subtask.materials_dev_subtotal,
                equipment_total: subtask.equipment_total,
                equipment_subtotal: subtask.equipment_subtotal,
                equipment_dev_subtotal: subtask.equipment_dev_subtotal,
                quantity: subtask.quantity
            };

            bid.subtasks.push(new_sub);

            _.each(subtask.materials, function(mat) {
                var time = new Date().getTime();
                if(mat.material_id) {
                    mat.material_id = mat.material_id;
                } else {
                    var inlist = $filter('filter')(bid.materials, {
                        'material_id': time }, true);

                    if(inlist.length > 0) {
                        //something kind of random
                        mat.material_id = time + getRandomInt(5, 1000);
                    } else {
                        mat.material_id = time;
                    }
                }
                mat.is_option = true;
                mat.option_number = item.number;
                mat.is_multiple = item.is_multiple;
                if(!mat.multi_data) mat.multi_data = [];

                var inlist = $filter('filter')(mat.multi_data, {
                    'option_number': item.number, 'lot': item.lot, 'phase': item.phase }, true);

                if(inlist.length === 0) {
                    mat.multi_data.push({
                        option_number: item.number,
                        multiple: item.multiple,
                        lot: item.lot,
                        phase: item.phase
                    });
                } else {
                    inlist[0].multiple = item.multiple;
                }

                mat.quantity = (aceUtils.isUndefinedOrZero(mat.quantity))?
                                mat.quantity_allowed: mat.quantity;

                if(!mat.option_revision) mat.option_revision = [];

                mat.option_revision.push({
                    number: item.revision,
                    quantity: (aceUtils.isUndefinedOrZero(mat.quantity))?
                        mat.quantity_allowed: mat.quantity,
                    price_per_order: mat.price_per_order,
                    delivery_price: mat.delivery_price,
                    unit: mat.unit,
                    lot: item.lot,
                    phase: item.phase
                });

                bid.materials.push(mat);
            });

            _.each(subtask.equipment, function(equip) {
                var time = new Date().getTime();
                if(equip.equipment_id) {
                    equip.equipment_id = equip.equipment_id;
                } else {
                    var inlist = $filter('filter')(bid.equipment, {
                        'material_id': time }, true);

                    if(inlist.length > 0) {
                        //something kind of random
                        equip.equipment_id = time + getRandomInt(5, 1000);
                    } else {
                        equip.equipment_id = time;
                    }
                }
                equip.is_option = true;
                mat.option_number = item.number;
                equip.is_multiple = item.is_multiple;
                if(!equip.multi_data) equip.multi_data = [];

                var inlist = $filter('filter')(equip.multi_data, {
                    'option_number': item.number, 'lot': item.lot, 'phase': item.phase }, true);

                if(inlist.length === 0) {
                    equip.multi_data.push({
                        option_number: item.number,
                        multiple: item.multiple,
                        lot: item.lot,
                        phase: item.phase
                    });
                } else {
                    inlist[0].multiple = item.multiple;
                }

                equip.quantity = (aceUtils.isUndefinedOrZero(equip.quantity))?
                                equip.quantity_allowed: equip.quantity;
                bid.equipment.push(equip);
            });
        };

        var removeProjectBidSubtaskFromSubtask = function(subtask, bid, option) {
            //var removed_all_by_option = true;
            _.each(subtask.materials, function(mat) {
                var inlist = {};
                if(mat.material_id) {
                    inlist = $filter('filter')(bid.materials, {
                        'material_id': mat.material_id }, true);
                } else {
                    inlist = $filter('filter')(bid.materials, {
                        'supplier': mat.supplier,
                        'unit': mat.unit,
                        'name': mat.name }, true);

                    if(inlist.length > 1) {
                        inlist = $filter('filter')(bid.materials, {
                            '_id': mat._id }, true);
                    }
                }

                if(inlist.length !== 1) {
                    var mat_indexes = [];
                    _.each(bid.materials, function(item, index) {
                        var foundItem = $filter('filter')(item.multi_data, {
                            'option_number': option.number, 'lot': option.lot,
                            'phase': option.phase}, true);

                        if(foundItem.length === 1) {
                            mat_indexes.push(index)
                        } else if(foundItem.length > 1) {
                            toaster.pop('error', 'foundItem Value Not Expected');
                        }
                    });

                    mat_indexes = $filter('orderBy')(mat_indexes, {});
                    for(var i = mat_indexes.length-1; i >= 0; i--) {
                        bid.materials.splice(mat_indexes[i], 1);
                    }

                    //removed_all_by_option = true;
                } else {
                    var idx = bid.materials.indexOf(inlist[0]);

                    if(idx === -1) {
                        toaster.pop('error', 'Material Not Found',
                            'Could not find material in bid.  Contact Admin');
                    } else {
                        bid.materials.splice(idx, 1);
                    }
                }
            });

            var inlist = $filter('filter')(bid.subtasks, {
                'name': subtask.name, 
                'description': subtask.description,
                'unit': subtask.unit }, true);

            if(inlist.length === 1) {
                var idx = bid.subtasks.indexOf(inlist[0]);
                bid.subtasks.splice(idx, 1);
            } else {
                var sub_indexes = []; //store indexes of subtasks to remove

                _.each(inlist, function(sub, index) {
                    var isInList = $filter('filter')(sub.multi_data, {
                        'option_number': option.number, 'lot': option.lot,
                        'phase': option.phase}, true);

                    if(isInList.length === 1) {
                        sub_indexes.push(index)
                    } else if(isInList.length > 1) {
                        toaster.pop('error', 'This is a Problem');
                    }
                });

                if(sub_indexes.length === 1) {
                    var idx = bid.subtasks.indexOf(sub_indexes[0]);
                    bid.subtasks.splice(idx, 1);
                } else if(sub_indexes.length > 1) {
                    toaster.pop('error', 'Case not handled');
                } else {
                    //have to reduce the list a little more
                    inlist = $filter('filter')(inlist, {
                        'crew_rate': subtask.crew_rate, 
                        'piece_rate': subtask.piece_rate,
                        'piece_per_hour_rate': subtask.piece_per_hour_rate,
                        'hours_allowed': subtask.hours_allowed }, true);

                    console.log('matched up a total of ' + inlist.length);

                    if(inlist.length === 1) {
                        var idx = bid.subtasks.indexOf(inlist[0]);
                        bid.subtasks.splice(idx, 1);
                    } else {
                        toaster.pop('error', 'Removing Subtask',
                            'Could not determine subtask to remove.  Removing last.');
                        var idx = bid.subtasks.indexOf(inlist[inlist.length-1]);
                        bid.subtasks.splice(idx, 1);
                    }
                }
            }
        };

        var updateSubtaskTotals = function(subtask, costs) {
            var labor = 0
            var work_comp = 0;
            subtask.current_net_pay = taskTotalsService.getCurrentNetPay(
                subtask.hours_allowed, subtask.crew_rate, subtask.quantity, subtask.piece_rate);
            if(subtask.crew_rate < costs.w_comp_break)
                work_comp = costs.w_comp_high;
            else
                work_comp = costs.w_comp_low;

            subtask.materials_subtotal = 0;
            subtask.materials_dev_subtotal = 0;
            subtask.material_total = 0;

            _.each(subtask.materials, function(mat) {
                if(!mat.quantity) mat.quantity = 0;
                if(!mat.quantity_allowed) mat.quantity_allowed = 0;
                if(!mat.price_per_order) mat.price_per_order = 0;
                if(!mat.piece_per_size) mat.piece_per_size = 0;
                if(!mat.delivery_price) mat.delivery_price = 0;
                if(!mat.material_total) mat.material_total = 0;
                if(!mat.materials_subtotal) mat.materials_subtotal = 0;
                if(!mat.materials_dev_subtotal) mat.materials_dev_subtotal = 0;

                mat.quantity_allowed = taskTotalsService.getQuantityAllowed(subtask,mat);
                
                //basic totals
                mat.materials_subtotal = taskTotalsService.getMaterialTotal(subtask,mat);
                mat.materials_dev_subtotal = taskTotalsService.getDevSubtotal(subtask,mat);

                //add delivery to subtotal
                subtask.materials_subtotal += mat.materials_subtotal;
                subtask.materials_dev_subtotal += taskTotalsService.getDevSubtotal(subtask,mat);
                subtask.material_total += mat.materials_subtotal + 
                    (mat.materials_subtotal * costs.sales_tax) +
                    mat.materials_dev_subtotal;
            });

            subtask.equipment_subtotal = 0;
            subtask.equipment_dev_subtotal = 0;
            subtask.equipment_total = 0;

            _.each(subtask.equipment, function(mat) {
                if(!mat.quantity) mat.quantity = 0;
                if(!mat.quantity_allowed) mat.quantity_allowed = 0;
                if(!mat.price_per_order) mat.price_per_order = 0;
                if(!mat.piece_per_size) mat.piece_per_size = 0;
                if(!mat.delivery_price) mat.delivery_price = 0;
                if(!mat.equipment_total) mat.equipment_total = 0;
                if(!mat.equipment_subtotal) mat.equipment_subtotal = 0;
                if(!mat.equipment_dev_subtotal) mat.equipment_dev_subtotal = 0;

                mat.quantity_allowed = taskTotalsService.getQuantityAllowed(subtask,mat);
                
                //basic totals
                mat.equipment_subtotal = taskTotalsService.getMaterialTotal(subtask,mat);
                mat.equipment_dev_subtotal = taskTotalsService.getDevSubtotal(subtask,mat);

                //add delivery to subtotal
                subtask.equipment_subtotal += mat.equipment_subtotal;
                subtask.equipment_dev_subtotal += taskTotalsService.getDevSubtotal(subtask,mat);
                subtask.equipment_total += mat.equipment_subtotal + 
                    (mat.equipment_subtotal * costs.equipment_tax) +
                    mat.equipment_dev_subtotal;
            });

            subtask.work_comp = subtask.current_net_pay * work_comp;

            labor = subtask.current_net_pay + subtask.work_comp;
            subtask.labor = labor + subtask.current_net_pay * costs.payroll_taxes;

            subtask.bid_mark_up = (subtask.labor * costs.labor) + 
                    (subtask.material_total * costs.material) + 
                    (subtask.equipment_total * costs.equipment);

            subtask.general_liability = (subtask.labor + subtask.material_total + 
                subtask.equipment_total + subtask.bid_mark_up) * costs.general_liability;

            subtask.total = subtask.labor + subtask.material_total + 
                subtask.equipment_total + subtask.bid_mark_up + subtask.general_liability;
        };

        //bid_subtask is (bids[0].subtasks[subtask.subtask_array_id])
        //bid_materials is (bids[0].materials)
        var updateProjectBidSubtaskFromOption = function(
            item, lot, subtask, bid_materials, bid_equipments, costs, bid_subtask, multiple) {
            if(typeof bid_subtask === 'undefined') {
                toaster.pop('error', 'Bid Subtask Error', 
                    'The bid subtask for ' + subtask.name + ' cannot be found.  Might need to regenerate the bid data.');
            } else {
                // there is bid data in project bids that needs
                // to be updated with this subtasks information
                bid_subtask.materials_dev_subtotal = 0;
                bid_subtask.materials_subtotal = 0;
                bid_subtask.material_total = 0;

                if(!subtask.labor) {
                    taskTotalsService.getSubtaskCalculations([subtask], costs);
                    var quantity = subtask.quantity - bid_subtask.quantity;
                    var total = (subtask.is_overridden)?subtask.overridden_total:subtask.total;
                    total -= bid_subtask.total;
                }

                bid_subtask.crew_rate = subtask.crew_rate;
                bid_subtask.hours_allowed = subtask.hours_allowed;
                bid_subtask.is_overridden = subtask.is_overridden;
                bid_subtask.overridden_total = subtask.overridden_total;
                bid_subtask.piece_per_hour_rate = subtask.piece_per_hour_rate;
                bid_subtask.piece_rate = subtask.piece_rate;
                bid_subtask.quantity += quantity;
                bid_subtask.total += total;
                bid_subtask.labor_total = subtask.labor;
                bid_subtask.current_net_pay = subtask.current_net_pay;
                bid_subtask.bid_mark_up = subtask.bid_mark_up;
                bid_subtask.general_liability = subtask.general_liability;
                bid_subtask.work_comp = subtask.work_comp;

                optionService.optionMaterialAddOrUpdate(
                    item, lot, subtask.materials, bid_materials, bid_subtask, multiple);

                optionService.addUpBidSubtaskMaterialTotal(bid_subtask, bid_materials, costs.material);

                optionService.optionEquipmentAddOrUpdate(
                    item, lot, subtask.equipment, bid_equipments, bid_subtask, multiple);

                optionService.addUpBidSubtaskEquipmentTotal(bid_subtask, bid_equipments, costs.equipment);

                bid_subtask.is_option = true;
                bid_subtask.is_multiple = (multiple>1)?true:false;

                var lot_num = (lot.lot)?lot.lot:lot.number;
                var inlist = $filter('filter')(bid_subtask.multi_data, {
                    'option_number': item.number, 'lot': lot_num, 'phase': item.phase }, true);

                if(inlist.length === 0) {
                    bid_subtask.multi_data.push({
                        option_number: item.number,
                        multiple: item.multiple,
                        lot: lot_num,
                        phase: lot.phase
                    });
                } else {
                    inlist[0].multiple = item.multiple;
                }

                bid_subtask.original_total = bid_subtask.total;
            }
        };

        //bid_subtask is (bids[0].subtasks[subtask.subtask_array_id])
        //bid_materials is (bids[0].materials)
        var updateProjectBidSubtaskFromOptionAndOriginal = function(
            item, lot, subtask, update_bid, original_bid, costs, subtask_index, multiple) {
            var bid_subtask = update_bid.subtasks[subtask_index];
            var original_subtask = original_bid.subtasks[subtask_index];
            var bid_materials = update_bid.materials;
            var bid_equipments = update_bid.equipment;

            if(typeof bid_subtask === 'undefined') {
                toaster.pop('error', 'Bid Subtask Error', 
                    'The bid subtask for ' + subtask.name + ' cannot be found.  Might need to regenerate the bid data.');
            } else {
                // there is bid data in project bids that needs
                // to be updated with this subtasks information
                bid_subtask.materials_dev_subtotal = 0;
                bid_subtask.materials_subtotal = 0;
                bid_subtask.material_total = 0;

                var quantity = 0;
                var total = 0;
                var hours_allowed = 0;
                var labor = 0;
                var current_net_pay = 0;
                var bid_mark_up = 0;
                var general_liability = 0;
                var work_comp = 0;

                if(original_subtask) {
                    quantity = subtask.quantity - original_subtask.quantity;
                    total = (subtask.is_overridden)?subtask.overridden_total:subtask.total;
                    total -= original_subtask.total;
                    hours_allowed = subtask.hours_allowed - original_subtask.hours_allowed;
                    labor = subtask.labor - original_subtask.labor_total;
                    current_net_pay = subtask.current_net_pay - original_subtask.current_net_pay;
                    bid_mark_up = subtask.bid_mark_up - original_subtask.bid_mark_up;
                    general_liability = subtask.general_liability - original_subtask.general_liability;
                    work_comp = subtask.work_comp - original_subtask.work_comp;
                } else {
                    quantity = subtask.quantity;
                    total = (subtask.is_overridden)?subtask.overridden_total:subtask.total;
                    hours_allowed = subtask.hours_allowed;
                    labor = subtask.labor;
                    current_net_pay = subtask.current_net_pay;
                    bid_mark_up = subtask.bid_mark_up;
                    general_liability = subtask.general_liability;
                    work_comp = subtask.work_comp;
                }

                //commenting out overridden for now.  the overridden amount is taken
                //in to account but multiple options modifying at given task makes me
                //think the overridden info should not be applied.
                //bid_subtask.is_overridden = subtask.is_overridden;
                //bid_subtask.overridden_total = subtask.overridden_total;
                
                //not sure what to do about rate information
                if(bid_subtask.piece_per_hour_rate != subtask.piece_per_hour_rate) {
                    console.log('RATE INFORMATION HAS CHANGED AND THE SYSTEM DOES NOT HANDLE YET.');
                }

                if(bid_subtask.crew_rate != subtask.crew_rate) {
                    console.log('RATE INFORMATION HAS CHANGED AND THE SYSTEM DOES NOT HANDLE YET.');
                }

                if(bid_subtask.piece_rate != subtask.piece_rate) {
                    console.log('RATE INFORMATION HAS CHANGED AND THE SYSTEM DOES NOT HANDLE YET.');
                }

                var lot_num = (lot.lot)?lot.lot:lot.number;
                var inlist = $filter('filter')(bid_subtask.multi_data, {
                    'option_number': item.number, 'lot': lot_num, 'phase': item.phase }, true);

                if(inlist.length === 0) {
                    bid_subtask.multi_data.push({
                        option_number: item.number,
                        multiple: multiple,
                        lot: lot_num,
                        phase: lot.phase
                    });
                } else {
                    inlist[0].multiple = multiple;
                }

                bid_subtask.quantity += quantity * multiple;
                bid_subtask.hours_allowed += hours_allowed * multiple;
                bid_subtask.total += total * multiple;
                bid_subtask.labor_total += labor * multiple;
                bid_subtask.current_net_pay += current_net_pay * multiple;
                bid_subtask.bid_mark_up += bid_mark_up * multiple;
                bid_subtask.general_liability += general_liability * multiple;
                bid_subtask.work_comp += work_comp * multiple;

                optionService.optionMaterialAddOrUpdate(
                    item, lot, subtask.materials, bid_materials, bid_subtask, multiple);

                optionService.addUpBidSubtaskMaterialTotal(bid_subtask, bid_materials, costs.material);

                optionService.optionEquipmentAddOrUpdate(
                    item, lot, subtask.equipment, bid_equipments, bid_subtask, multiple);

                optionService.addUpBidSubtaskEquipmentTotal(bid_subtask, bid_equipments, costs.equipment);

                bid_subtask.is_option = true;
                bid_subtask.is_original = true;
                bid_subtask.is_multiple = (multiple>1)?true:false;

                bid_subtask.original_total = bid_subtask.total;
            }
        };

        var applyBidTaskMultiple = function(bid, multiple) {
            console.log('apply bid multiple');
            var hours = 0;
            var current_net_pay = 0;
            var labor = 0;
            _.each(bid.subtasks, function(subtask) {
                if(subtask.is_option) {
                    subtask.quantity *= multiple;
                    subtask.current_net_pay *= multiple;
                    subtask.hours_allowed *= multiple;
                    subtask.labor_total *= multiple;
                    subtask.material_total *= multiple;
                    subtask.equipment_total *= multiple;
                    subtask.is_multiple = true;
                }
                
                hours += subtask.hours_allowed;
                current_net_pay += subtask.current_net_pay;
                labor += subtask.labor_total;
            });

            bid.totals.hours_allowed = hours;
            bid.totals.current_net_pay = current_net_pay;
            bid.totals.labor = labor;

            _.each(bid.materials, function(mat) {
                if(mat.is_option) {
                    mat.quantity *= multiple;
                    mat.delivery_price *= multiple;
                    mat.materials_subtotal *= multiple;
                    mat.is_multiple = true;
                }
            });

            _.each(bid.equipment, function(mat) {
                if(mat.is_option) {
                    mat.quantity *= multiple;
                    mat.delivery_price *= multiple;
                    mat.materials_subtotal *= multiple;
                    mat.is_multiple = true;
                }
            });

            return bid;
        };

        //bid_tasks is ($scope.bid_tasks)
        //trade_bids is ($scope.trade_bids)
        var findBidSubtasksForOptionUpdates = function(
            item, lot, option_subtasks, bid_tasks, trade_bids, multiple) {
            var update_bids = [];
            option_subtasks = $filter('filter')(option_subtasks, {'revision': item.revision},true);

            _.each(option_subtasks, function(subtask) {
                // first get the project bid associated with this subtask
                var bids = [];
                var bid_task_found = true;
                var inlist = $filter('filter')(update_bids, {
                    'plan_code': subtask.plan, 'task_code': subtask.code }, true);

                if(inlist.length === 0) {
                    bids = $filter('filter')(bid_tasks, {
                        'plan_code': subtask.plan, 'task_code': subtask.code }, true);

                    if(bids.length === 0) {
                        //this most likely means we are dealing with lot revisions
                        // toaster.pop('error', 'Problem With Bid Task', 
                        //     'Could not get the bid task from the list.');
                        bids = bid_tasks;
                        bid_task_found = false;
                    } else if(bids.length > 1) {
                        //this most likely means we are dealing with lot revisions
                        //need to get the revision info from the lot and then find the bid
                        var lotRev = $filter('filter')(lot.revisions, {
                            'trade': trade_bids[0].trade}, true)[0];

                        if(lotRev) {
                            var tmpBid = $filter('filter')(bids, {
                                'revision':lotRev.revision}, true);
                            if(tmpBid.length === 1) {
                                // tmpBid[0].lot = (lot.lot)?lot.lot:lot.number;
                                // tmpBid[0].phase = lot.phase;
                                bids = tmpBid;
                            } else {
                                tmpBid = $filter('filter')(bids, {
                                    'latest':true }, true);
                                if(tmpBid.length === 1) {
                                    // tmpBid[0].lot = (lot.lot)?lot.lot:lot.number;
                                    // tmpBid[0].phase = lot.phase;
                                    bids = tmpBid;
                                } else {
                                    bid_task_found = false;
                                }
                            }
                        }
                    }
                } else if(inlist.length === 1) {
                    // inlist[0].lot = (lot.lot)?lot.lot:lot.number;
                    // inlist[0].phase = lot.phase;
                    bids.push(inlist[0]);
                }

                if(bid_task_found) {
                    //this is the first time we've done options stuff.  
                    //store the original totals.
                    if(!bids[0].has_options) {
                        bids[0].original_totals = angular.copy(bids[0].totals);
                        bids[0].has_options = true;
                        bids[0].need_to_save = true;
                        bids[0].lot = (lot.lot)?lot.lot:lot.number;
                        bids[0].phase = lot.phase;
                    }

                    // there could be more than one trade in $scope.trade_bids
                    var trades = $filter('filter')(trade_bids, {
                        'trade': bids[0].trade }, true);

                    if(trades.length !== 1) {
                        toaster.pop('error', 'Problem With Determining Trade', 
                            'Could not get the trade bid from the bid task.');
                    } else {
                        if(subtask.bid_subtask) {
                            updateProjectBidSubtaskFromOption(
                                item, lot, subtask, bids[0].materials, bids[0].equipment, trades[0].costs,
                                bids[0].subtasks[subtask.subtask_array_id], multiple);
                        } else {
                            item.lot = (lot.lot)?lot.lot:lot.number,
                            item.phase = lot.phase;
                            item.is_multiple = (multiple>1)?true:false;
                            console.log('adding subtask ' + subtask.name + ' to lot ' + item.lot);

                            if(!subtask.labor) {
                                //this subtask does not have calculations applied so we should do that now.
                                taskTotalsService.getSubtaskCalculations([subtask], trades[0].costs);
                            }
                            // this subtask is not part of the project bid
                            // so just add it's information
                            addProjectBidSubtaskFromSubtask(subtask, bids[0], item);
                        }

                        if(multiple > 1) {
                            console.log('we have a multiple');
                            applyBidTaskMultiple(bids[0], multiple);
                        }

                        var bid_in_list = $filter('filter')(update_bids, {
                            '_id': bids[0]._id }, true);

                        if(bid_in_list.length === 0) {
                            update_bids.push(bids[0]);
                        }
                    }
                }
            });

            //total up the results prior to returning
            //this is where we want to create new projectBid
            //records or update a projectBid if it exists.
            _.each(update_bids, function(bid) {
                bid.totals.current_net_pay = 0;
                bid.totals.equipment = 0;
                bid.totals.equipment_dev_subtotal = 0;
                bid.totals.equipment_subtotal = 0;
                bid.totals.general_liability = 0;
                bid.totals.hours_allowed = 0;
                bid.totals.labor = 0;
                bid.totals.mark_up = 0;
                bid.totals.materials = 0;
                bid.totals.materials_dev_subtotal = 0;
                bid.totals.materials_subtotal = 0;
                bid.totals.work_comp = 0;
                bid.totals.total = 0;
                _.each(bid.subtasks, function(sub) {
                    bid.totals.current_net_pay += sub.current_net_pay;
                    bid.totals.equipment += (sub.equipment_total)?sub.equipment_total:0;
                    bid.totals.equipment_dev_subtotal += 
                        (sub.equipment_dev_subtotal)?sub.equipment_dev_subtotal:0;
                    bid.totals.equipment_subtotal += 
                        (sub.equipment_subtotal)?sub.equipment_subtotal:0;
                    bid.totals.general_liability += sub.general_liability;
                    bid.totals.hours_allowed += sub.hours_allowed;
                    bid.totals.labor += sub.labor_total;
                    bid.totals.mark_up += sub.bid_mark_up;
                    bid.totals.materials += (sub.material_total)?sub.material_total:0;
                    bid.totals.materials_dev_subtotal += 
                        (sub.materials_dev_subtotal)?sub.materials_dev_subtotal:0;
                    bid.totals.materials_subtotal += 
                        (sub.materials_subtotal)?sub.materials_subtotal:0;
                    bid.totals.work_comp += sub.work_comp;
                    if(sub.is_overridden) {
                        bid.totals.total += sub.overridden_total;
                    } else {
                        bid.totals.total += sub.total;
                    }
                });
            });

            return update_bids;
        };

        //trade_options is ($scope.trade_options.options)
        //costs is ($scope.trade_bids[0].costs)
        var getOptionBidSubtasks = function(trade_options, item, lot, costs) {
            var options = [];
            var option_subtasks = [];

            options = optionService.getTradeOptions(
                trade_options, lot.number, item.trades);

            option_subtasks = 
                optionService.filterOptionSubtasksOnPlans(options, lot.plan);

            taskTotalsService.getSubtaskCalculations(
                option_subtasks, costs);

            return option_subtasks;
        };

        //subtask is the option subtask
        //bid_task is the ProjectBid record with options applied
        //original_bid is the ProjectBid with no options applied (same plan code)
        var findBidSubtasksForOptionRemoval = function(
            item, lot, subtask, bid_task, original_bid, costs) {
            if(subtask.bid_subtask) {
                _.each(bid_task.subtasks, function(bid_subtask, idx) {
                    if(bid_subtask.is_option) {
                        let inlist = $filter('filter')(bid_subtask.multi_data, {
                            'option_number': item.number, 'lot': lot.lot, 'phase': lot.phase }, true);

                        //found it
                        if(inlist.length > 0) {
                            var orig_subtask = $filter('filter')(original_bid.subtasks, {
                                '_id': bid_subtask._id }, true);

                            if(orig_subtask.length === 1) {
                                //bid_subtask = orig_subtask[0];
                                bid_task.subtasks.splice(idx, 1, orig_subtask[0]);
                            } else {
                                console.log('issue finding subtask');
                            }
                        }
                    }
                });

                _.each(bid_task.materials, function(bid_material, idx) {
                    if(bid_material.is_option) {
                        let inlist = $filter('filter')(bid_material.multi_data, {
                            'option_number': item.number, 'lot': lot.lot, 'phase': lot.phase }, true);

                        //found it
                        if(inlist.length > 0) {
                            var orig_material = $filter('filter')(original_bid.materials, {
                                '_id': bid_material._id }, true);

                            if(orig_material.length === 1) {
                                //bid_subtask = orig_material[0];
                                bid_task.materials.splice(idx, 1, orig_material[0]);
                            } else {
                                console.log('issue finding materials');
                            }
                        }
                    }
                });
            } else {
                // this subtask is not part of the project bid
                // so just remove it's information based on the option
                // loop backwards through the ProjectBid's subtasks and
                // look for subtasks that are options and only applied
                // for the particular option and lot.
                for(let i = bid_task.subtasks.length-1; i>=0; i--) {
                    //item.number is the option we are removing and 
                    //lot.lot is for what particular lot
                    // first check to make sure this subtask is an option
                    if(bid_task.subtasks[i].is_option) {
                        let inlist = $filter('filter')(bid_task.subtasks[i].multi_data, {
                            'option_number': item.number, 'lot': lot.lot, 'phase': lot.phase }, true);

                        //found it
                        if(inlist.length > 0) {
                            bid_task.subtasks.splice(i, 1);
                        }
                    }
                }

                //do the same for materials
                for(let i = bid_task.materials.length-1; i>=0; i--) {
                    //item.number is the option we are removing and 
                    //lot.lot is for what particular lot
                    // first check to make sure this subtask is an option
                    if(bid_task.materials[i].is_option) {
                        let inlist = $filter('filter')(bid_task.materials[i].multi_data, {
                            'option_number': item.number, 'lot': lot.lot, 'phase': lot.phase }, true);

                        //found it
                        if(inlist.length > 0) {
                            bid_task.materials.splice(i, 1);
                        }
                    }
                }

                //do the same for materials
                for(let i = bid_task.equipment.length-1; i>=0; i--) {
                    //item.number is the option we are removing and 
                    //lot.lot is for what particular lot
                    // first check to make sure this subtask is an option
                    if(bid_task.equipment[i].is_option) {
                        let inlist = $filter('filter')(bid_task.equipment[i].multi_data, {
                            'option_number': item.number, 'lot': lot.lot, 'phase': lot.phase }, true);

                        //found it
                        if(inlist.length > 0) {
                            bid_task.equipment.splice(i, 1);
                        }
                    }
                }
            }

            bid_task.totals.current_net_pay = 0;
            bid_task.totals.equipment = 0;
            bid_task.totals.equipment_dev_subtotal = 0;
            bid_task.totals.equipment_subtotal = 0;
            bid_task.totals.general_liability = 0;
            bid_task.totals.hours_allowed = 0;
            bid_task.totals.labor = 0;
            bid_task.totals.mark_up = 0;
            bid_task.totals.materials = 0;
            bid_task.totals.materials_dev_subtotal = 0;
            bid_task.totals.materials_subtotal = 0;
            bid_task.totals.work_comp = 0;
            bid_task.totals.total = 0;
            _.each(bid_task.subtasks, function(sub) {
                bid_task.totals.current_net_pay += sub.current_net_pay;
                bid_task.totals.equipment += sub.equipment_total;
                bid_task.totals.equipment_dev_subtotal += sub.equipment_dev_subtotal;
                bid_task.totals.equipment_subtotal += sub.equipment_subtotal;
                bid_task.totals.general_liability += sub.general_liability;
                bid_task.totals.hours_allowed += sub.hours_allowed;
                bid_task.totals.labor += sub.labor_total;
                bid_task.totals.mark_up += sub.bid_mark_up;
                bid_task.totals.materials += sub.material_total;
                bid_task.totals.materials_dev_subtotal += sub.materials_dev_subtotal;
                bid_task.totals.materials_subtotal += sub.materials_subtotal;
                bid_task.totals.work_comp += sub.work_comp;
                if(sub.is_overridden) {
                    bid_task.totals.total += sub.overridden_total;
                } else {
                    bid_task.totals.total += sub.total;
                }
            });
        };

        //trade_option is ($scope.trade_options.options)
        //trade_bids is ($scope.trade_bids)
        //bid_tasks is ($scope.bid_tasks)
        var addOrRemoveOptionFromBidSubtasks = function(trade_option, item, lot, 
            trade_bids, bid_tasks, proj_lot, active, is_multiple) {
            var option_subtasks = [];

            option_subtasks = getOptionBidSubtasks(
                trade_option, item, lot, trade_bids[0].costs);

            if(active) {
                //add the option to the project bid and update totals
                findBidSubtasksForOptionUpdates(
                    item, lot, option_subtasks, bid_tasks, trade_bids, is_multiple);

                //add the option information to the project lot
                var inlist = $filter('filter')(proj_lot[0].active_options, {
                    'number': lot.number }, true);

                if(inlist.length === 0) {
                    proj_lot[0].active_options.push({
                        number: lot.number,
                        name: lot.name,
                        totals: [{
                            multiple: (item.multiple)?item.multiple:1,
                            option_revision: (item.revision.number)?item.revision.number:item.revision,
                            trade: trade_bids[0].trade,
                            total: 0
                        }]
                    });
                } else {
                    console.log('THIS IS A BIG PROBLEM!!!!  Option already exists on lot');
                }
            } else {
                //remove the option information from the project bid
                findBidSubtasksForOptionRemoval(
                    item, lot, option_subtasks, bid_tasks, trade_bids);

                //now remove the option off of the project.lot
                var option = $filter('filter')(proj_lot[0].active_options, {
                    'number': lot.number }, true);

                var idx = proj_lot[0].active_options.indexOf(option[0]);

                if(idx === -1) {
                    toaster.pop('error', 'Problem finding option',
                        'Could not get the option.  Contact Admin');
                } else {
                    proj_lot[0].active_options.splice(idx, 1);
                }
            }
        };

        //user_trade is ($scope.user.trade[0])
        var addOptionTotalToProjectLot = function(item, lot, proj_lot, user_trade) {
            //cost has the new value for this option
            var cost = $filter('filter')(item.lots, {
                'lot': lot.lot, 'phase': lot.phase }, true);

            if(cost.length !== 1) {
                toaster.pop('error', 'Getting Project Cost', 'Contact Admin');
                return;
            }

            if(!cost[0].cost || cost[0].cost ===0) {
                console.log('might be a problem with the cost');
            }

            console.log(proj_lot);

            if(cost[0].active) {
                var project_options = $filter('filter')(proj_lot[0].active_options, {
                    'number': cost[0].number }, true);

                if(project_options.length !== 1) {
                    toaster.pop('error', 'Error Project Lot Options', 'Contact Admin');
                    return;
                }

                if(project_options[0].totals) {
                    var inlist = [];

                    inlist = $filter('filter')(project_options[0].totals, {
                        'trade': user_trade, 'option_revision': item.revision.number }, true);

                    if(inlist.length === 0) {
                        project_options[0].totals.push({
                            trade: user_trade,
                            total: cost[0].cost,
                            multiple: lot.multiple,
                            option_revision: (item.revision.number)?item.revision.number:item.revision,
                        });
                    } else if(inlist.length === 1) {
                        inlist[0].total = cost[0].cost;
                        inlist[0].multiple = lot.multiple;
                        //inlist[0].option_revision = (item.revision.number)?item.revision.number:1;
                    } else {
                        toaster.pop('error', 'Contact Admin', 'Error Project Trade Lot Options');
                        return;
                    }
                } else {
                    project_options[0].totals = [];
                    project_options[0].totals.push({
                        trade: user_trade,
                        total: cost[0].cost,
                        multiple: lot.multiple,
                        option_revision: (item.revision.number)?item.revision.number:item.revision
                    });
                }
            }
        };

        return {
            getProjectBidTotal: getProjectBidTotal,
            getProjectOriginalBidTotal: getProjectOriginalBidTotal,
            convertProjectBidToBid: convertProjectBidToBid,
            addProjectBidSubtaskFromSubtask: addProjectBidSubtaskFromSubtask,
            removeProjectBidSubtaskFromSubtask: removeProjectBidSubtaskFromSubtask,
            updateProjectBidSubtaskFromOption: updateProjectBidSubtaskFromOption,
            updateProjectBidSubtaskFromOptionAndOriginal: updateProjectBidSubtaskFromOptionAndOriginal,
            findBidSubtasksForOptionUpdates: findBidSubtasksForOptionUpdates,
            getOptionBidSubtasks: getOptionBidSubtasks,
            findBidSubtasksForOptionRemoval: findBidSubtasksForOptionRemoval,
            addOrRemoveOptionFromBidSubtasks: addOrRemoveOptionFromBidSubtasks,
            addOptionTotalToProjectLot: addOptionTotalToProjectLot,
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/services/project-options-service.js